export default __webpack_public_path__ + "static/media/4.01f9f82d.jpg";